import React from "react";
import { Dropdown } from "react-bootstrap";
import i18n from "../i8next";

const Languages = [
  { key: "en", name: "English", flagUrl: "https://flagcdn.com/us.svg" }, // USA
  { key: "es", name: "Español", flagUrl: "https://flagcdn.com/es.svg" }, // Spain
  {
    key: "fr",
    name: "Français",
    flagUrl: "https://flagcdn.com/fr.svg",
  },
];

const LanguageSlector = () => {
  const lang = (i18n?.resolvedLanguage || i18n?.language || "en").toLowerCase();
  const currentLang = lang === "fr" ? "FR" : lang === "es" ? "ES" : "EN";

  return (
    <>
      <Dropdown align="end" className="relative me-2">
        <Dropdown.Toggle
          variant="light"
          id="dropdown-language"
          className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 rounded-md bg-white text-gray-700 text-sm font-medium hover:bg-gray-100"
        >
          <span>{currentLang}</span>
          {/* <FaChevronDown className='w-4 h-4' /> */}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="mt-1 p-0 border rounded-md shadow-md overflow-hidden w-40"
          style={{ minWidth: "7rem" }}
        >
          {Languages.map((lang, index) => (
            <Dropdown.Item
              as="button"
              key={index}
              onClick={() => i18n.changeLanguage(lang.key)}
              className={`flex items-center gap-2 px-2 py-2 cursor-pointer ${
                lang.key === i18n.language ? "bg-gray-300" : "hover:bg-gray-300"
              }`}
            >
              <img
                src={lang.flagUrl}
                alt={lang.key}
                className="object-cover pe-2 rounded-sm"
                style={{ width: "30px" }}
              />
              <span className="text-medium" style={{ fontSize: "15px" }}>
                {lang.name}
              </span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default LanguageSlector;
